"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dog = void 0;
var moment = require("moment");
var common_1 = require("../common");
var Dog = /** @class */ (function (_super) {
    __extends(Dog, _super);
    function Dog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dog.ageFrom = function (dob, unit, date) {
        return (date ? date : moment())
            .diff(dob, unit, true);
    };
    Dog.defaultProps = function (id) {
        var dob = moment()
            .subtract(3, 'months');
        return {
            id: id,
            name: '',
            breeds: [],
            touched: false,
            dob: dob.toISOString(),
            img: '',
            gender: null,
            neutered: null,
            obeseProne: null,
            activity: {
                dailyFeedAmount: 2,
                exerciseAmount: null
            },
            personality: {
                pickiness: 1,
                chewAmount: 1
            },
            size: {
                // @TODO this should get set in the server
                shapeLevel: 5,
                weight: {
                    value: null,
                    measurement: 'lbs'
                },
                length: {
                    value: null,
                    measurement: 'in'
                },
                chest: {
                    value: null,
                    measurement: 'in'
                },
                neck: {
                    value: null,
                    measurement: 'in'
                },
                heightFromShoulder: {
                    value: null,
                    measurement: 'in'
                }
            },
            growth: [],
            type: 'NORMAL',
            allergies: [],
            dietPreferences: []
            // journey: DogJourney.defaultProps()
        };
    };
    return Dog;
}(common_1.AbstractModelLight));
exports.Dog = Dog;
